import { formatInTimeZone } from 'date-fns-tz';
import AVAILABLE_TIMEZONES from 'admin-panel/constants/timezones';

type Timezone = typeof AVAILABLE_TIMEZONES[number];
type TimezoneOption = Timezone & { label: string };

export function timezoneDisplayLabel(
  iana: string,
  date: Date = new Date()
): string {
  return `${iana} (${formatInTimeZone(date, iana, 'OOOO')})`;
}

export function getAvailableTimezoneOptions(
  date: Date = new Date()
): TimezoneOption[] {
  return AVAILABLE_TIMEZONES.map((timezone) => ({
    ...timezone,
    label: timezoneDisplayLabel(timezone.iana, date),
  }));
}
